(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio
   * @description
   *
   */
  angular
    .module('itecAdministracio', [
      'ui.router',
      'itecApi',
      'itecAdministracio.api',
      'itecAdministracio.shared',
      'itecLocale',
      'itecGuicomponents.layout',
      'itecGuicomponents.commonControls',
      'itecGuicomponents.calendar',
      'ngDraggable',
      'ngCookies',
      'ngFileSaver',
      'itecAdministracio.usuaris',
      'itecAdministracio.entitats',
      'itecAdministracio.rols',
      'itecAdministracio.productes'
    ])
    .config(function($translatePartialLoaderProvider, $urlRouterProvider, $httpProvider) {
       $httpProvider.defaults.useXDomain = true;

      $translatePartialLoaderProvider.addPart('resources');
      $translatePartialLoaderProvider.addPart('vendor/itec-guicomponents/dist/resources/common-controls/resources');
   })
   .config(function($httpProvider) {
      $httpProvider.interceptors.push('LocaleInterceptorFactory');
   })
	 .run(function($rootScope, LocalStorage, DataFactory, ApiLayoutConstant, SessionStorage, PermisosFactory, LocaleService, AdmConstant) {

      //Configuració per itec-guicomponents
      LocalStorage.setBasePath('itecAdministracio');
      SessionStorage.setBasePath('itecAdministracio');
      $rootScope.prefixItecGuicomponents = 'vendor/itec-guicomponents/dist/';

      DataFactory.setApiParameters('security', ApiLayoutConstant.SERVER_VERSION_ADMINISTRACIO, 'authsecurity','');
      PermisosFactory.setApiParameters(AdmConstant.SERVER_PATH_ADMINISTRACIO + 'permisos', 'pagenotfound');

      //Pedimos permisos (y creamos sesion y desbloqueamos la api)
      PermisosFactory.load().then(function(response){
        $rootScope.permisos = response.data.permisos;
        $rootScope.usuari = response.data.usuari;
        $rootScope.issuperadmin = response.data.issuperadmin;
      }).catch(function(error){
        console.log(error);
        $state.go(errorState);
      }).finally(function(){
        DataFactory.unblockApi();
        AppFactory.setExistsSession(true);
      });

      DataFactory.blockApi();
    });
}());
